import * as React from "react";
import { DatePicker } from "antd";
import moment from "moment";

export interface State {
  isOpen: boolean;
}

export interface Props {
  onChange: (value: moment.Moment | null) => void;
  placeholder?: string;
  disabled?: boolean;
  value?: moment.Moment | null;
}

export default class YearPicker extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      ...props,
      isOpen: false
    };
  }

  openDatePicker() {
    this.setState({ isOpen: true });
  }

  closeDatePicker() {
    this.setState({ isOpen: false });
  }

  render() {
    const { isOpen } = this.state;

    const { onChange, placeholder, disabled, value } = this.props;

    return (
      <DatePicker
        mode={"year"}
        open={isOpen}
        value={value}
        format="YYYY"
        placeholder={placeholder || ""}
        disabled={disabled || false}
        onPanelChange={(value) => {
          onChange(value);
          this.closeDatePicker();
        }}
        onOpenChange={(status) => {
          if (status) {
            this.openDatePicker();
          } else {
            this.closeDatePicker();
          }
        }}
      />
    );
  }
}
